import { assign, object, optional, partial } from 'superstruct';
import { parsableInteger } from '@arc/shared/util-superstruct';
import { BaseFilter } from './base-filter.dto';
export const EditFilterDto = assign(partial(BaseFilter), object({
  id: optional(parsableInteger())
}));